/* eslint-disable no-bitwise, import/prefer-default-export, consistent-return */
import React, { useState, useEffect, Fragment } from 'react';
import { isEmpty, get, isNumber } from 'lodash';
import Social from '../social/social';
import PropTypes from 'prop-types';
import axios from 'axios';
import EventModel from '../../../utils/tracking/models';

export const StickyBar = ({
  slug,
  post,
  activeTab,
  setActiveTab,
  location,
  scroll,
  externalData,
  hideTopBorder
}) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [lists, setLists] = useState([]);
  const [landerUrl, setLanderUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(null);

  const checkIfMobile = x => {
    setIsMobile(x.matches);
  };

  // Detect screen size on render, and watch for changes to it.
  useEffect(() => {
    const x = window.matchMedia('(max-width: 640px)');
    checkIfMobile(x);

    x.addEventListener('change', checkIfMobile);
    return () => x.removeEventListener('change', checkIfMobile);
  }, []);

  useEffect(
    () => {
      if (isMobile && setActiveTab) setActiveTab(0);
    },
    [isMobile]
  );

  const determineBrightness = backgroundColor => {
    const color = backgroundColor.substring(1); // strip #
    const rgb = parseInt(color, 16); // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff; // extract red
    const g = (rgb >> 8) & 0xff; // extract green
    const b = (rgb >> 0) & 0xff; // extract blue

    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    if (luma < 128) {
      return '#FFFFFF';
    }
    return '#000000';
  };

  const handleCategoryChange = idx => {
    if (location === 'lander') {
      setActiveTab(idx);
      scroll();
    } else {
      window.location.href = landerUrl ? `${landerUrl}?view=${idx}` : '#';
    }
  };

  const handlePopup = e => {
    if (/^http/gi.test(e.currentTarget.value)) {
      window.location.href = e.currentTarget.value;
    }
  };

  const handleNavListClick = (arr, position) => {
    const clickEvent = new EventModel(
      `BWI Bottom Sticky Nav- ${get(arr, 'category', 'no category')}`,
      'bottomNavClick',
      'click',
      `nav-${get(arr, 'category', 'no category')}`,
      `${position + 1} | ${arr.length}`
    );

    clickEvent.triggerTrackingEvent(
      'default-click',
      clickEvent.getTrackingObject()
    );
  };

  const buildContent = type => {
    switch (type) {
      case 'title':
        return (
          <a
            href={data.link_url ? `${data.link_url}` : `/${data.slug}`}
            target="_blank"
            style={{ color: data.text_color }}
            onClick={e => {
              if (location === 'lander') {
                e.preventDefault();
                scroll();
              }
            }}
          >
            {data.display_name}
          </a>
        );

      case 'categories':
        return (
          <Fragment>
            {lists.map((list, i) => (
              <div
                className="bottomStickyNav-content_box"
                style={{
                  borderLeftColor: data.border_color,
                  color:
                    location === 'article' || activeTab === i
                      ? data.text_color
                      : '#CCC',
                  ...(slug === 'bwi-2022' &&
                    activeTab === i && { background: '#ec008c' })
                }}
                key={`box-${i}`}
              >
                <a
                  style={{
                    color:
                      location === 'article' || activeTab === i
                        ? data.text_color
                        : '#CCC',
                    ...(slug === 'bwi-2022' &&
                      activeTab === i && { color: '#fff' })
                  }}
                  onClick={() => handleCategoryChange(i)}
                >
                  {list.category}
                </a>

                {data.display_category_index === i && (
                  <div className="hiddenDropdown">
                    <select onChange={e => handlePopup(e)}>
                      {list.data.map((category, j) => (
                        <option
                          value={category.url}
                          onClick={() => handleNavListClick(list, j)}
                        >
                          {category.title}
                        </option>
                      ))}
                    </select>
                    <button>▲</button>
                  </div>
                )}
              </div>
            ))}
          </Fragment>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (isEmpty(data)) {
      axios(`https://fc-api.fastcompany.com/api/v1/navs/tag/${slug}`)
        .then(res => {
          setData(res.data);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(
            `Error trying to load data for bottom navigation: ${error}`
          );
        });
    }
  }, []);

  useEffect(
    () => {
      if (data.display_type === 'categories') {
        axios(
          `https://fc-api.fastcompany.com/api/v1/franchise/${slug}?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07`
        )
          .then(res => {
            const franchise = () => {
              if (/^bwi/gi.test(slug)) return 'best_workplaces_for_innovators';
              if (/^ibd/gi.test(slug)) return 'innovation_by_design';
            };

            if (externalData.length > 0) {
              setLists(externalData);
            } else {
              setLists(res.data.acf[franchise(slug)].lists);
            }

            if (location === 'article') {
              const url = {
                slug: franchise(slug).replace(/_/gi, '-'),
                year: slug.match(/\d{4}$/gi)[0]
              };

              setLanderUrl(`/${url.slug}/${url.year}`);
            }
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.error(
              `Error trying to load list data for bottom navigation: ${error}`
            );
          });
      }
    },
    [data]
  );

  if (
    !slug ||
    isEmpty(data) ||
    data.error ||
    (data.display_type === 'categories' && isEmpty(lists))
  ) {
    return false;
  }

  return (
    <div
      className={`bottomStickyNav ${
        hideTopBorder ? 'bottomStickyNav--hideTopBorder' : ''
      }`}
      style={{
        backgroundColor: data.background_color,
        borderColor: data.border_color
      }}
    >
      <div className="bottomStickyNav-content">
        {buildContent(data.display_type)}
      </div>

      <div
        className="bottomStickyNav-social"
        style={{ borderColor: data.border_color }}
        onClick={() => setOpen(!open)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34.66"
          height="23.4"
          viewBox="0 0 34.66 23.4"
        >
          <path
            style={{ fill: determineBrightness(data.background_color) }}
            d="M30.553-8.851a23.706,23.706,0,0,0-7.446,3.16A27.918,27.918,0,0,0,19-2.432V-15.269a27.93,27.93,0,0,0,4.108,3.258,23.711,23.711,0,0,0,7.446,3.16"
            transform="translate(4.106 20.712)"
          />
          <path
            style={{ fill: determineBrightness(data.background_color) }}
            d="M4-8.3H26.082v-1.964H4Z"
            transform="translate(0.875 21.177)"
          />
          <path
            style={{ fill: determineBrightness(data.background_color) }}
            d="M316.027,407.7H296.973V384.3h19.055v7.275h-2V386.3H298.973v19.4h15.055V400.35h2Z"
            transform="translate(-296.973 -384.3)"
          />
        </svg>

        {open && (
          <div className="bottomStickyNav__icons">
            <Social
              modifier="StickyBar"
              disableStyle={true}
              hideRecirc={true}
              text={get(post, 'customFields.facebook_social_copy', post.title)}
              uri={
                get(data, 'link_url', null) && !isNumber(get(post, 'id'))
                  ? `https://www.fastcompany.com${get(data, 'link_url')}`
                  : `https://www.fastcompany.com/${get(post, 'id')}/${get(
                      post,
                      'slug'
                    )}`
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

StickyBar.propTypes = {
  slug: PropTypes.string.isRequired,
  post: PropTypes.shape({}).isRequired,
  activeTab: PropTypes.number,
  setActiveTab: PropTypes.func,
  location: PropTypes.string.isRequired,
  scroll: PropTypes.func,
  externalData: PropTypes.shape([]),
  hideTopBorder: PropTypes.bool
};

StickyBar.defaultProps = {
  activeTab: null,
  setActiveTab: null,
  scroll: null,
  externalData: [],
  hideTopBorder: false
};
